import React, {Component} from 'react'
import {TabContent, TabPane, Nav, NavItem, NavLink, Row, Col} from 'reactstrap'
import {Query} from 'react-apollo'
import classnames from 'classnames'
import {ToastContainer} from 'react-toastify'

import Loading from "../Loading"
import UserDetailsForm from "./UserDetailsForm"

import query from '../../../queries/server/user'
import UserPermissionsForm from "./UserPermissionsForm"
import {checkPermission, USER_PERMISSIONS_CAN_CHANGE_USER_PERMISSIONS} from "../../../lib/permissions";
import UserRoleHistory from "./UserRoleHistory";


export default class User extends Component {

    state = {
        activeTab: 'details'
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    render() {
        const {user_id} = this.props.match.params

        return (

            <Query query={query} variables={{user_id}}>
                {({data, loading, error}) => {

                    if (loading) return <Loading/>

                    console.log(data)

                    return (
                        <div className="m-4">

                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === 'details'})}
                                        onClick={() => {
                                            this.toggle('details');
                                        }}
                                    >
                                        Details
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === 'permissions'})}
                                        onClick={() => {
                                            this.toggle('permissions');
                                        }}
                                        disabled={!checkPermission(USER_PERMISSIONS_CAN_CHANGE_USER_PERMISSIONS)}
                                    >
                                        Permissions
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({active: this.state.activeTab === 'user_role'})}
                                        onClick={() => {
                                            this.toggle('user_role');
                                        }}
                                    >
                                        User Role
                                    </NavLink>
                                </NavItem>
                            </Nav>

                            <TabContent activeTab={this.state.activeTab}>
                                <TabPane tabId="details">
                                    <Row>
                                        <Col sm="12 mt-4">
                                            <UserDetailsForm user={data.user}/>
                                        </Col>
                                    </Row>
                                </TabPane>

                                <TabPane tabId="permissions">
                                    <Row>
                                        <Col sm="12 mt-4">
                                            <UserPermissionsForm user={data.user}/>
                                        </Col>
                                    </Row>
                                </TabPane>

                                <TabPane tabId="user_role">
                                    <Row>
                                        <Col sm="12 mt-4">
                                            <UserRoleHistory user_id={user_id} data={data.user.user_role_history}/>
                                        </Col>
                                    </Row>
                                </TabPane>
                            </TabContent>
                            <ToastContainer/>
                        </div>
                    )

                }}
            </Query>
        )
    }

}